import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment';

export interface RegistrationVerificationRequest {
  email: string;
}

export interface RegistrationVerificationResult {
  queued?: boolean;
  message?: string;
}

export interface EmailVerificationConfirmResult {
  confirmed?: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RegistrationVerificationService {
  private verificationUrl = `${environment.apiUrl}/Auth/email-verification`;

  constructor(private http: HttpClient) {}

  requestEmailVerification(email: string): Observable<RegistrationVerificationResult> {
    return this.http.post<RegistrationVerificationResult>(`${this.verificationUrl}/request`, { email });
  }

  confirmEmailVerification(token: string): Observable<EmailVerificationConfirmResult> {
    return this.http.post<EmailVerificationConfirmResult>(`${this.verificationUrl}/confirm`, { token });
  }

  confirmEmailVerificationFromLink(token: string): Observable<EmailVerificationConfirmResult> {
    const params = new HttpParams().set('token', token);
    return this.http.get<EmailVerificationConfirmResult>(`${this.verificationUrl}/confirm`, { params });
  }
}
